function getOrganizationsByAvailability(organizationData, productData) {
    if (!organizationData) {
        return {
            availableOrganizations: [],
            unavailableOrganizations: [],
        };
    }

    const { organizations } = organizationData;

    if (!productData) {
        return {
            availableOrganizations: organizations,
            unavailableOrganizations: [],
        };
    }

    const available = [];
    const unavailable = [];

    organizations.forEach((organization) => {
        const { organizationGroups } = organization;

        let isAvailable;
        if (!organizationGroups) {
            isAvailable = false; // If an organization has no organizationGroups, it is not allowed to order products.
        } else {
            isAvailable = organizationGroups.some((groupId) => {
                return productData.organizationGroups.includes(groupId);
            });
        }

        if (isAvailable) {
            available.push({ ...organization });
        } else {
            unavailable.push({ ...organization });
        }
    });

    return {
        availableOrganizations: available,
        unavailableOrganizations: unavailable,
    };
}

export { getOrganizationsByAvailability };
